import moment from 'moment';
import { AgencyLocationInfo } from 'src/app/modules/administration/constants/agency-location';
import { AgencyList } from '../../interface/agency-list';

export class AgencyAdminRequestModel {
  agencyLocationSk: string;
  agencySk: string;
  serviceStartTime?: Date;
  serviceEndTime?: Date;
  lunchStartTime?: Date;
  lunchEndTime?: Date;
  averageWaitTime?: number;
  dateFrequency?: number;
  totalAppointmentsMonday?: number;
  totalAppointmentsTuesday?: number;
  totalAppointmentsWednesday?: number;
  totalAppointmentsThursday?: number;
  totalAppointmentsFriday?: number;
  totalAppointmentsSaturday?: number;
  totalAppointmentsSunday?: number;
  totalStaffMonday?: number;
  totalStaffTuesday?: number;
  totalStaffWednesday?: number;
  totalStaffThursday?: number;
  totalStaffFriday?: number;
  totalStaffSaturday?: number;
  totalStaffSunday?: number;
  languages?: number[];
  languageList?: string[] | string;
  bilingualPsychologist?: boolean;
  bilingualInterpreter?: boolean;
  onSite?: string;
  offSite?: string;
  serviceManhattan?: string;
  serviceBronx?: string;
  serviceBrooklyn?: string;
  serviceQueens?: string;
  serviceStatenIsland?: string;
  sheval?: string;
  psychoEval?: string;
  counseling?: string;
  pteval?: string;
  oteval?: string;
  location?: AgencyLocationInfo;
  siteLocation: string;
  agencyTypeId: number;
  operatingMDE?: string;
  constructor(data: AgencyList, referenceData: AgencyLocationInfo[]) {
    this.agencySk = data?.agencySk;
    this.serviceStartTime = data?.serviceStartTime
      ? moment(data?.serviceStartTime).toDate()
      : null;
    this.serviceEndTime = data?.serviceEndTime
      ? moment(data?.serviceEndTime).toDate()
      : null;
    this.lunchStartTime = data?.lunchStartTime
      ? moment(data?.lunchStartTime).toDate()
      : null;
    this.lunchEndTime = data?.lunchEndTime
      ? moment(data?.lunchEndTime).toDate()
      : null;
    this.averageWaitTime = data?.averageWaitTime;
    this.dateFrequency = data?.dateFrequency;
    this.totalAppointmentsMonday = data?.totalAppointmentsMonday;
    this.totalAppointmentsTuesday = data?.totalAppointmentsTuesday;
    this.totalAppointmentsWednesday = data?.totalAppointmentsWednesday;
    this.totalAppointmentsThursday = data?.totalAppointmentsThursday;
    this.totalAppointmentsFriday = data?.totalAppointmentsFriday;
    this.totalAppointmentsSaturday = data?.totalAppointmentsSaturday;
    this.totalAppointmentsSunday = data?.totalAppointmentsSunday;
    this.totalStaffMonday = data?.totalStaffMonday;
    this.totalStaffTuesday = data?.totalStaffTuesday;
    this.totalStaffWednesday = data?.totalStaffWednesday;
    this.totalStaffThursday = data?.totalStaffThursday;
    this.totalStaffFriday = data?.totalStaffFriday;
    this.totalStaffSaturday = data?.totalStaffSaturday;
    this.totalStaffSunday = data?.totalStaffSunday;
    this.languages =
      Array.isArray(data?.languages) && data.languages.length
        ? data.languages
        : this.mapLanguages(data?.languageOfService);

    this.languageList = data?.languageList;
    this.bilingualPsychologist = data?.bilingualPsychologist;
    this.bilingualInterpreter = data?.bilingualInterpreter;
    this.onSite = data?.onSite ? data?.onSite.toString() : '';
    this.offSite =data?.offSite? data?.offSite.toString() : '';
    this.serviceManhattan = data?.serviceManhattan? data?.serviceManhattan.toString() : '';
    this.serviceBronx = data?.serviceBronx? data?.serviceBronx?.toString() : '';
    this.serviceBrooklyn =data?.serviceBrooklyn? data?.serviceBrooklyn.toString() : '';
    this.serviceQueens =data?.serviceQueens? data?.serviceQueens.toString() : '';
    this.serviceStatenIsland =data?.serviceStatenIsland? data?.serviceStatenIsland.toString() : '';
    this.sheval = data?.sheval;
    this.psychoEval = data?.psychoEval? data?.psychoEval.toString() : '';
    this.counseling = data?.counseling?data?.counseling.toString() : '';
    this.pteval =data?.pteval? data?.pteval.toString() : '';
    this.oteval =data?.oteval? data?.oteval.toString() : '';
    this.location = referenceData?.find(
      (details: AgencyLocationInfo) =>
        details?.agencyLocationSK === data.agencyLocationSk
    );
    this.siteLocation = data?.siteLocation;
    this.agencyTypeId = data?.agencyTypeId;
    this.operatingMDE = data?.operatingMDE?.toString();
  }

  get id(): string {
    return this.agencySk;
  }
    private mapLanguages(value?: string): number[] {
    if (!value) {
      return [];
    }

    return value
      .split(',')
      .map((v: string) => Number(v.trim()))
      .filter((v: number) => !isNaN(v));
  }
}
